export enum GradientType {
  linear = <any>'linear',
  radial = <any>'radial'
}
